import { render, staticRenderFns } from "./PlanUpgradeView.vue?vue&type=template&id=72de0482&"
import script from "./PlanUpgradeView.vue?vue&type=script&lang=js&"
export * from "./PlanUpgradeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports